module.exports = __webpack_public_path__ + "static/media/logo2.cd061b1d.svg";